import Apparel from '@/public/images/for-business/business/apparel.webp';
import Beauty from '@/public/images/for-business/business/beauty.webp';
import Creatives from '@/public/images/for-business/business/creatives.webp';
import Furniture from '@/public/images/for-business/business/furniture.webp';
import Graphics from '@/public/images/for-business/business/graphics.webp';
import Jewelery from '@/public/images/for-business/business/jewelery.webp';
import RealEstate from '@/public/images/for-business/business/realEstate.webp';
import Visuals from '@/public/images/for-business/business/visuals.webp';

export const forBusinessData = [
	{
		text: 'imagesData.apparel',
		subText: 'imagesData.apparelSubText',
		image: Apparel,
		size: 'wide',
		link: 'apparel-photography',
	},
	{
		text: 'imagesData.furniture',
		subText: 'imagesData.furnitureSubText',
		image: Furniture,
		size: 'wide',
		link: 'furniture-images',
	},
	{
		text: 'imagesData.beauty',
		subText: 'imagesData.beautySubText',
		image: Beauty,
		link: 'beauty-product-photography',
	},
	{
		text: 'imagesData.jewelery',
		subText: 'imagesData.jewelerySubText',
		image: Jewelery,
		link: 'jewelery-photography',
	},
	{
		text: 'imagesData.creatives',
		subText: 'imagesData.creativesSubText',
		image: Creatives,
		link: 'online-ad-creatives',
	},
	{
		text: 'imagesData.graphics',
		subText: 'imagesData.graphicsSubText',
		image: Graphics,
		size: 'wide',
		link: 'branded-sm-graphics',
	},
	{
		text: 'imagesData.visuals',
		subText: 'imagesData.visualsSubText',
		image: Visuals,
		size: 'wide',
		link: 'email-marketing-visuals',
	},
	{
		text: 'imagesData.realEstate',
		subText: 'imagesData.realEstateSubText',
		image: RealEstate,
		size: 'small',
		link: 'real-estate-listings',
	},
];
